import { DegreeLevelOption } from '@uc/web/shared/data-models';

export const DEGREE_LEVEL_TYPE_MAPPER = {
	undergraduate: 'ALL_UNDERGRADUATE',
	degrees: 'BACHELOR',
	foundation: 'FOUNDATION',
	'undergraduate-certificate-diplomas': 'UG_CERTIFICATE_AND_DIPLOMA',
	hnd: 'HND',
	hnc: 'HNC',
	'access-to-higher-education': 'ACCESS_TO_HIGHER_EDUCATION',
	postgraduate: 'ALL_POSTGRADUATE',
	masters: 'MASTER',
	phd: 'PHD',
	'postgraduate-certificate-diplomas': 'PG_CERTIFICATE_AND_DIPLOMA',
	pgce: 'PGCE',
	'postgraduate-certificate': 'PG_CERTIFICATE',
	'postgraduate-diploma': 'PG_DIPLOMA',
	clearing: 'ALL_CLEARING',
};

export const BASIC_DEGREE_LEVEL_OPTIONS: DegreeLevelOption[] = [
	{ label: 'Undergraduate', link: 'undergraduate' },
	{ label: 'Postgraduate', link: 'postgraduate' },
];

export const CLEARING_DEGREE_LEVEL_OPTION: DegreeLevelOption = {
	label: 'Clearing',
	link: 'clearing',
};
